import { Component, Vue } from 'vue-property-decorator';
import { UserId } from '@/types/user';
import { Request, LeaveTypeId } from '@/types/request';

@Component({})
export default class FiltersService extends Vue {
  get selectedLeaveTypes() {
    return this.$store.getters['leaveTypes/selected'];
  }

  get selectedUsers(): UserId[] {
    return this.$store.getters['users/selected'];
  }

  public applyRequestFilters(requests: Request[]): Request[] {
    return requests.filter((request: Request) => {
      if (!this.selectedUsers.length) {
        return true;
      }
      const selected = this.selectedUsers.some((id: UserId) => id === request.userId!);
      return selected;
    })
    .filter((requestObject: Request) => {
      if (!this.selectedLeaveTypes.length) {
        return true;
      }
      const selected = this.selectedLeaveTypes.some((id: LeaveTypeId) => id === requestObject.leaveTypeId!);
      return selected;
    });
  }

}
